export type CommissionCandidate = {
  id: string | number
  commission: 'available' | 'counted' | 'excluded'
  counted_in_note?: { id: string | number; reference: string } | null
}

/** Only a document whose commission is still available can be ticked. */
export const isSelectable = (document: CommissionCandidate) =>
  document.commission === 'available'

/** The ids of the ticked documents that can still be added, in the list order. */
export function selectedAvailableIds(
  documents: CommissionCandidate[],
  selected: (string | number)[]
) {
  return documents
    .filter(
      (document) => isSelectable(document) && selected.includes(document.id)
    )
    .map((document) => document.id)
}

/** First day of the month and today, as YYYY-MM-DD: the default period to look at. */
export function defaultPeriod(today = new Date()) {
  const pad = (value: number) => String(value).padStart(2, '0')
  const day = (date: Date) =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`

  return {
    from: day(new Date(today.getFullYear(), today.getMonth(), 1)),
    to: day(today)
  }
}
